/**
 * Contact Email Section Component
 * Displays contact email with show/hide functionality
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface ContactEmailSectionProps {
  contactEmail: string | null | undefined;
  showContactEmail: boolean;
  onShowContactEmail: () => void;
}

export const ContactEmailSection: React.FC<ContactEmailSectionProps> = ({
  contactEmail,
  showContactEmail,
  onShowContactEmail,
}) => {
  if (!contactEmail) return null;

  if (!showContactEmail) {
    return (
      <button
        type="button"
        className="inline-block mt-2 text-xs text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300 px-2 py-1 border border-blue-100 dark:border-blue-700 rounded cursor-pointer"
        onClick={onShowContactEmail}
      >
        <FormattedMessage id="jobDetailPage.showContact" defaultMessage="Show Contact Email" description="Button label to reveal contact email address" />
      </button>
    );
  }

  return (
    <a
      href={`mailto:${contactEmail}`}
      className="inline-block mt-2 text-xs text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage id="jobDetailPage.contact" defaultMessage="Contact:" description="Label prefix for contact email address" /> {contactEmail}
    </a>
  );
};
